"use client"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import React from "react"

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = React.useState(() => new QueryClient())
  const isDevelopment = process.env.NODE_ENV === "development"

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDevelopment ? (
        <ReactQueryDevtools
          buttonPosition='bottom-right'
          initialIsOpen={false}
        />
      ) : null}
    </QueryClientProvider>
  )
}
